import { render } from "./ReconditionAd.vue?vue&type=template&id=1924c2d6"
import script from "./ReconditionAd.vue?vue&type=script&lang=js"
export * from "./ReconditionAd.vue?vue&type=script&lang=js"
script.render = render

export default script